import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { compose } from 'redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../../component/app/commonReducer';
import { THEMES } from '../../../../configs/LayoutConfig';
import { withComponentId } from '../../../common/ComponentIdContext';
import Table from '../../../common/table/Table';
import { TIME_FILTERS } from '../../financial-statement/Const';
import {
  YEARLY,
  mapping,
  bankingMapping,
  INDUSTRY,
  ignoreMappings,
  defaultIndicatorBanking,
  defaultIndicator,
  subIndicators,
  groupIndicators,
  groupIndicatorsBanking,
} from '../constants';
import { fetchData, REDUCER_NAME, resetCompares, resetData } from '../reducer';
import Minus from '../../../../assets/images/svg/fundamental/minus.svg';
import Plus from '../../../../assets/images/svg/fundamental/plus.svg';

import MinusBlack from '../../../../assets/images/svg/fundamental/minus_black.svg';
import PlusBlack from '../../../../assets/images/svg/fundamental/plus_black.svg';
import RatioSetting from './RatioSetting';

const RATIO_NAME_WIDTH = 250;
const END_OF_DATA = 'EndOfData';

const getCurrentTime = () => {
  const now = new Date();
  const month = now.getMonth();
  return {
    year: now.getFullYear(),
    quarter: Math.floor(month / 3) + 1,
  };
};

const getAvailableQuarter = (start, number = 7) => {
  const result = [start];
  for (let i = number - 1; i > 0; i--) {
    const [firsItem] = result;

    result.unshift({
      year: firsItem.quarter === 1 ? firsItem.year - 1 : firsItem.year,
      quarter: firsItem.quarter === 1 ? 4 : firsItem.quarter - 1,
    });
  }

  return result;
};

const getAvailableYear = (start, number = 7) => {
  const result = [
    {
      ...start,
      quarter: 5,
    },
  ];
  for (let i = number - 1; i > 0; i--) {
    const [firsItem] = result;

    result.unshift({
      year: firsItem.year - 1,
      quarter: 5,
    });
  }

  return result;
};

const getNumberColumn = width => {
  if (width > 1100) {
    return 10;
  }

  if (width > 1000 && width <= 1100) {
    return 9;
  }

  if (width <= 1000 && width > 900) {
    return 8;
  }

  if (width <= 900 && width > 800) {
    return 7;
  }

  if (width <= 800 && width > 700) {
    return 6;
  }

  if (width <= 700 && width > 600) {
    return 5;
  }

  if (width <= 600 && width > 500) {
    return 4;
  }

  if (width <= 500 && width > 400) {
    return 3;
  }

  return 2;
};

class FinancialRatioTable extends PureComponent {
  constructor(props) {
    super(props);
    const start = getCurrentTime();
    this.state = {
      skip: 0,
      minYear: null,
      minQuarter: null,
      maxYear: null,
      maxQuarter: null,
      columns: this.getColumns(start),
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { resetData, componentId, timeFilter, searchParams } = this.props;
    this.calcNewState(nextProps);
    if (
      searchParams.code !== nextProps.searchParams.code ||
      timeFilter !== nextProps.timeFilter
    ) {
      resetData(componentId);
      this.setState({
        columns: this.getColumns(getCurrentTime(), nextProps.timeFilter),
        maxYear: null,
        maxQuarter: null,
        minYear: null,
        minQuarter: null,
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { columns } = this.state;
    const {
      compares,
      searchParams,
      resetCompares,
      componentId,
      width,
      isFilterIndustry,
      timeFilter,
    } = this.props;

    const isChangeTicker = searchParams.code !== prevProps.searchParams.code;
    const isChangeIndustry = isFilterIndustry !== prevProps.isFilterIndustry;
    const isChangeTimeFilter = timeFilter !== prevProps.timeFilter;

    if (
      compares !== prevProps.compares ||
      isChangeTicker ||
      isChangeIndustry ||
      isChangeTimeFilter
    ) {
      this.fetchData();
    }
    if (searchParams.isBanking !== prevProps.searchParams.isBanking) {
      resetCompares(componentId);
    }

    if (width !== prevProps.width) {
      this.setState(
        {
          columns: this.getColumns(columns[columns.length - 1]),
        },
        this.fetchData,
      );
    }
  }

  getYearAndQuarter = string => {
    const [year, quarter] = string.split('_');

    return {
      year: +year,
      quarter: +quarter,
    };
  };

  calcNewState = nextProps => {
    const { maxYear, minYear, columns } = this.state;
    const { searchParams } = this.props;
    if (!Object.keys(nextProps.data).length) {
      return;
    }
    const ratioData = nextProps.data[searchParams.code];
    const ratioDataKeys = Object.keys(ratioData);
    const lastKey = ratioDataKeys[ratioDataKeys.length - 1];
    const [firstKey] = ratioDataKeys;
    if (
      ratioData[firstKey].organCode === END_OF_DATA &&
      ratioData[lastKey].organCode === END_OF_DATA &&
      !maxYear &&
      !minYear
    ) {
      const newColumns = [];
      ratioDataKeys.forEach(key => {
        if (ratioData[key].organCode === END_OF_DATA) {
          return;
        }
        newColumns.push(this.getYearAndQuarter(key));
      });
      if (!newColumns.length) {
        return;
      }
      this.setState({
        columns: newColumns,
        minYear: newColumns[0].year,
        minQuarter: newColumns[0].quarter,
        maxYear: newColumns[newColumns.length - 1].year,
        maxQuarter: newColumns[newColumns.length - 1].quarter,
      });
      return;
    }

    if (ratioData[lastKey].organCode === END_OF_DATA && !maxYear) {
      const endOfDataKeyIndex = ratioDataKeys.findIndex(
        key => ratioData[key].organCode === END_OF_DATA,
      );
      const { year, quarter } = this.getYearAndQuarter(
        ratioDataKeys[endOfDataKeyIndex - 1],
      );
      const newColumns = this.getColumns({
        year,
        quarter,
      });
      this.setState({
        maxYear: year,
        maxQuarter: quarter,
        columns: newColumns,
      });
      newColumns.forEach(column => {
        const key = `${column.year}_${column.quarter}`;
        if (!ratioData[key]) {
          this.fetchData([`${column.year}_${column.quarter}`]);
        }
      });
      return;
    }
    if (ratioData[firstKey].organCode === END_OF_DATA && !minYear) {
      const [_, key] = ratioDataKeys;
      const { year, quarter } = this.getYearAndQuarter(key);
      const lastColumn = columns[columns.length - 1];
      const nextTimeLine = this.getNextTimeLine({
        year: lastColumn.year,
        quarter: lastColumn.quarter,
      });
      this.setState({
        minYear: year,
        minQuarter: quarter,
        columns: this.getColumns(nextTimeLine),
      });
      return;
    }
  };

  getNextTimeLine = current => {
    const { timeFilter } = this.props;
    if (timeFilter === TIME_FILTERS.YEARLY) {
      return {
        quarter: +current.quarter,
        year: +current.year + 1,
      };
    }
    if (current.quarter === 4) {
      return {
        quarter: 1,
        year: +current.year + 1,
      };
    }
    return {
      quarter: +current.quarter + 1,
      year: +current.year,
    };
  };

  getTimeLine = () => {
    const { columns } = this.state;
    const timelines = [];
    columns.forEach(column => {
      const key = `${column.year}_${column.quarter}`;
      timelines.push(key);
    });
    return timelines;
  };

  fetchData = timelines => {
    const { fetchData, componentId } = this.props;
    const mapping = this.getMappingObject();
    fetchData({
      componentId,
      mapping,
      timelines: timelines || this.getTimeLine(),
    });
  };

  getColumns = (start, filter) => {
    const { width } = this.props;
    const timeFilter = filter || this.props.timeFilter;
    const numberOfColumn = getNumberColumn(width);
    return timeFilter === YEARLY
      ? getAvailableYear(start, numberOfColumn)
      : getAvailableQuarter(start, numberOfColumn);
  };

  canPrevious = () => {
    const { minYear, minQuarter, columns } = this.state;
    const { timeFilter } = this.props;
    if (timeFilter === YEARLY) {
      return columns[0].year > minYear;
    }

    return columns[0].year > minYear && columns[0].quarter > minQuarter;
  };

  canNext = () => {
    const { maxYear, maxQuarter, columns } = this.state;
    const { timeFilter } = this.props;
    const lastColumn = columns[columns.length - 1];
    if (timeFilter === YEARLY) {
      return lastColumn.year < maxYear;
    }

    if (lastColumn.year === maxYear) {
      return lastColumn.quarter < maxQuarter;
    }

    return lastColumn.year < maxYear;
  };

  prev = () => {
    const { columns } = this.state;
    const start = columns[columns.length - 2];
    const newColumns = this.getColumns(start);
    const [firstColumn] = newColumns;
    this.setState({
      columns: newColumns,
    });
    this.fetchData([`${firstColumn.year}_${firstColumn.quarter}`]);
  };

  next = () => {
    const { columns } = this.state;
    const { timeFilter } = this.props;
    const lastColumn = columns[columns.length - 1];
    if (timeFilter === YEARLY) {
      const start = {
        year: lastColumn.year + 1,
        quarter: 5,
      };
      this.setState({
        columns: this.getColumns(start),
      });
      this.fetchData([`${start.year}_${start.quarter}`]);
      return;
    }
    const start = {
      year: lastColumn.quarter === 4 ? lastColumn.year + 1 : lastColumn.year,
      quarter: lastColumn.quarter === 4 ? 1 : lastColumn.quarter + 1,
    };
    this.fetchData([`${start.year}_${start.quarter}`]);

    this.setState({
      columns: this.getColumns(start),
    });
  };

  getSchema = () => {
    const { columns } = this.state;
    const { listOrganizationByOrganCode, width } = this.props;
    const parentIndicators = this.getDefaultParentIndicator();
    const extraColumns = columns.map((item, index) => {
      const title =
        item.quarter === 5
          ? item.year.toString()
          : `Q${item.quarter} ${item.year}`;
      const extra = {};
      if (index === 0 && this.canPrevious()) {
        extra.title = (
          <div className="d-flex align-items-center justify-content-between">
            <i onClick={this.prev} className="icon-caret-left mr-5" />
            {title}
          </div>
        );
        extra.thTooltip = title;
      }

      if (index === columns.length - 1 && this.canNext()) {
        extra.title = (
          <div>
            {title}
            <i onClick={this.next} className="icon-caret-right ml-5" />
          </div>
        );
        extra.thTooltip = title;
      }
      const numberOfColumn = getNumberColumn(width);
      const columnWidth = Math.floor(
        (width - RATIO_NAME_WIDTH) / numberOfColumn,
      );

      return {
        title,
        disableSort: true,
        isHtml: true,
        thStyle: {
          width: `${columnWidth}px`,
        },
        key: `${item.year}_${item.quarter}`,
        ...extra,
        render: (text, item) => {
          let className = parentIndicators.includes(item.ratio)
            ? 'parent-indicator'
            : subIndicators.includes(item.ratio)
            ? 'sub-indicator'
            : '';
          const number = +text.toString().replace('%', '');
          if (number < 0) {
            className += ' text-negative';
          }

          return <div className={className}>{text}</div>;
        },
      };
    });

    return [
      {
        key: 'ratio',
        isHtml: true,
        disableSort: true,
        thStyle: {
          width: `${RATIO_NAME_WIDTH}px`,
        },
        title: (
          <RatioSetting
            defaultIndicators={this.getDefaultIndicators()}
            mapping={this.getMappingObject()}
          />
        ),
        render: text => {
          if (this.isNotCompare()) {
            const className = parentIndicators.includes(text)
              ? 'ratio-parent-group-item'
              : subIndicators.includes(text)
              ? 'ratio-group-item'
              : 'ratio-item';
            return (
              <div
                title={I18n.t(`financialAnalysis.financialRatio.${text}`)}
                className={className}
              >
                {I18n.t(`financialAnalysis.financialRatio.${text}`)}
              </div>
            );
          }

          if (!listOrganizationByOrganCode[text]) {
            const isIndustry = text === INDUSTRY;

            return (
              <div
                title={
                  isIndustry
                    ? this.getIndustryName()
                    : I18n.t(`financialAnalysis.financialRatio.${text}`)
                }
                className={
                  text !== INDUSTRY ? 'ratio-group-item' : 'ratio-item'
                }
              >
                {I18n.t(`financialAnalysis.financialRatio.${text}`)}
              </div>
            );
          }

          return listOrganizationByOrganCode[text].ticker;
        },
      },
    ].concat(extraColumns);
  };

  getMappingObject = () => {
    const { searchParams } = this.props;

    return searchParams.isBanking ? bankingMapping : mapping;
  };

  getDefaultIndicators = () => {
    const { searchParams } = this.props;

    return searchParams.isBanking ? defaultIndicatorBanking : defaultIndicator;
  };

  getDefaultParentIndicator = () => {
    const { searchParams } = this.props;

    return searchParams.isBanking ? groupIndicatorsBanking : groupIndicators;
  };

  getAvailableCodes = () => {
    const { searchParams, compares, isFilterIndustry } = this.props;
    const codes = [searchParams.code];
    if (isFilterIndustry) {
      return codes.concat(compares.map(item => item.code)).concat(INDUSTRY);
    }
    return codes.concat(compares.map(item => item.code));
  };
  getIndustryName = () => {
    const { companyScore, listIndustryByIcbCode } = this.props;
    const industry = listIndustryByIcbCode[companyScore.icbCode];

    return industry ? industry.icbName : '--';
  };

  getGroups = () => {
    const { theme, hideIndicators } = this.props;
    const mapping = this.getMappingObject();
    const codes = this.getAvailableCodes();
    const btnConfig = {
      Dark: {
        Minus: Minus,
        Plus: Plus,
      },
      Light: {
        Minus: MinusBlack,
        Plus: MinusBlack,
      },
      Classic: {
        Minus: Minus,
        Plus: Plus,
      },
    };
    const minusImg = btnConfig[theme].Minus;
    const plusImg = btnConfig[theme].Plus;
    const groups = [];
    Object.keys(mapping).forEach(key => {
      if (
        ignoreMappings.includes(mapping[key]) ||
        groupIndicators.includes(key) ||
        groupIndicatorsBanking.includes(key) ||
        hideIndicators[key]
      ) {
        return;
      }
      const ids = [];
      codes.forEach(code => {
        ids.push(`${code}_${key}`);
        if (key === 'netProfit') {
          ids.push(`${code}_profitGrowth`);
        }
        if (key === 'revenue') {
          ids.push(`${code}_revenueGrowth`);
        }
        if (key === 'netInterestIncome') {
          ids.push(`${code}_netInterestIncomeGrowth`);
        }
      });
      groups.push({
        renderTitle: isExpand => (
          <div className="d-flex align-items-center">
            <img
              className="expand"
              alt="expand"
              src={isExpand ? minusImg : plusImg}
            />
            {I18n.t(`financialAnalysis.financialRatio.${key}`)}
          </div>
        ),
        canToggle: true,
        ids: ids,
      });
    });

    return groups;
  };

  getIds = () => {
    const {
      searchParams: { code },
      hideIndicators,
    } = this.props;
    const ids = [];
    const mapping = this.getMappingObject();
    Object.keys(mapping).forEach(key => {
      if (ignoreMappings.includes(mapping[key]) || hideIndicators[key]) {
        return;
      }
      ids.push(`${code}_${key}`);
      if (key === 'netProfit') {
        ids.push(`${code}_profitGrowth`);
      }
      if (key === 'revenue') {
        ids.push(`${code}_revenueGrowth`);
      }
      if (key === 'netInterestIncome') {
        ids.push(`${code}_netInterestIncomeGrowth`);
      }
    });

    return ids;
  };

  getParentIds = () => {
    const {
      searchParams: { code },
      hideIndicators,
    } = this.props;
    const ids = [];
    const mapping = this.getMappingObject();
    Object.keys(mapping).forEach(key => {
      if (ignoreMappings.includes(mapping[key]) || hideIndicators[key]) {
        return;
      }
      ids.push(`${code}_${key}`);
      if (key === 'netProfit') {
        ids.push(`${code}_profitGrowth`);
      }
      if (key === 'revenue') {
        ids.push(`${code}_revenueGrowth`);
      }
      if (key === 'netInterestIncome') {
        ids.push(`${code}_netInterestIncomeGrowth`);
      }
    });

    return ids;
  };

  isNotCompare = () => {
    const { compares, isFilterIndustry } = this.props;
    return !compares.length && !isFilterIndustry;
  };

  getDataFromRedux = state => {
    const { componentId } = this.props;
    const { columns } = this.state;
    const { data } = state[REDUCER_NAME][componentId];
    const result = {};
    this.getAvailableCodes().forEach(code => {
      if (!data[code]) {
        return;
      }
      Object.keys(this.getMappingObject()).forEach(field => {
        let ratio = code;
        if (subIndicators.includes(field) || this.isNotCompare()) {
          ratio = field;
        }
        const value = { ratio }; // display code
        columns.forEach(column => {
          const valueKey = `${column.year}_${column.quarter}`;
          if (!data[code][valueKey]) {
            value[valueKey] = undefined;
            return;
          }

          value[valueKey] = data[code][valueKey][field];
        });

        result[`${code}_${field}`] = value;
      });
    });

    return result;
  };

  render() {
    const { isLoading } = this.props;
    const extraProps = this.isNotCompare()
      ? { ids: this.getIds(), parentIds: this.getParentIds }
      : { groups: this.getGroups() };

    return (
      <div className="mt-10 d-flex flex-column flex-fill financial-ratio-table">
        <Table
          {...extraProps}
          isLoading={isLoading}
          stickyFirstColumn={false}
          resizeable={false}
          getDataFromRedux={this.getDataFromRedux}
          schema={this.getSchema()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => ({
  timeFilter: state[REDUCER_NAME][componentId].timeFilter,
  isLoading: state[REDUCER_NAME][componentId].isLoading,
  locale: state.i18n.locale,
  searchParams: state[REDUCER_NAME][componentId].searchParams,
  compares: state[REDUCER_NAME][componentId].compares,
  isFilterIndustry: state[REDUCER_NAME][componentId].isFilterIndustry,
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
  theme: state.theme,
  data: state[REDUCER_NAME][componentId].data,
  hideIndicators: state[REDUCER_NAME][componentId].hideIndicators,
  companyScore: state[REDUCER_NAME][componentId].companyScore,
  listIndustryByIcbCode: state[COMMON_REDUCER_NAME].listIndustryByIcbCode,
});

const mapDispatchToProps = {
  fetchData,
  resetCompares,
  resetData,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(FinancialRatioTable);
